<base-modal-component class="base-modal"  (onConfirm)="save()" [autoHide]="false">

    <file-upload [control]="fileUploadControl"></file-upload>


</base-modal-component>
